<template>
  <b-modal
    :id="'treasury-override-modal'"
    :cancel-title="$t('Cancel')"
    centered
    no-close-on-backdrop
    :ok-title="$t('Add')"
    size="xs"
    ok-variant="primary"
    cancel-variant="outline-primary"
    @close="emitCloseModal"
    @hide="resetModal"
    @ok="addOrUpdateMovementOverride"
    @submit.stop.prevent="addOrUpdateMovementOverride">
    <template #modal-header="{ close }">
      <div class="modalHeader">
        <div>
          <h5 class="modal-title mb-0">{{ $t('Modify') }} {{ movement.movementName }}</h5>
          <div v-if="movement.takeFrom.toString() === '1'" class="page-subtitle">Emprunt</div>
          <div v-if="movement.takeFrom.toString() === '2'" class="page-subtitle">Investisseurs</div>
          <div v-if="movement.takeFrom.toString() === '3'" class="page-subtitle">Trésorerie</div>
        </div>
      </div>
    </template>

    <div>
      <b-form ref="formMovement" @submit.stop.prevent="addOrUpdateMovementOverride">
        <b-form-group
          :invalid-feedback="form.date.invalidFeedback"
          :label="$t('chargePro.Date') "
          :state="form.date.state"
          class="medium-label mb-4"
          label-for="date-input">
          <datepicker-input
            id="date-input"
            v-model="form.date.value"
            :state="form.date.state"
            required>
          </datepicker-input>
        </b-form-group>
        <b-form-group
          v-if="movement.canUpdateMontant"
          :invalid-feedback="form.montant.invalidFeedback"
          :label="$t('chargePro.Value') "
          :state="form.montant.state"
          class="medium-label mb-4"
          label-for="montant-input">
          <b-form-input
            id="montant-input"
            v-model="form.montant.value"
            v-disable-scroll
            required
            step="any"
            type="number">
          </b-form-input>
        </b-form-group>
        <b-form-group
          v-else
          :invalid-feedback="form.montant.invalidFeedback"
          :label="$t('chargePro.Value') "
          :state="form.montant.state"
          class="medium-label mb-4"
          label-for="montant-input">
          <b-form-input
            id="montant-input"
            v-model="form.montant.value"
            v-disable-scroll
            required
            disabled
            step="any"
            type="number">
          </b-form-input>
        </b-form-group>
        <b-form-group
          :invalid-feedback="form.takeFrom.invalidFeedback"
          :state="form.takeFrom.state"
          :label="$t('treasury.takeFrom')"
          class="medium-label"
          label-for="takeFrom-input">
          <b-form-select
            id="takeFrom-input"
            :invalid-feedback="form.takeFrom.invalidFeedback"
            :state="form.takeFrom.state"
            v-model="form.takeFrom.value"
            v-on:change="removeInvalidFeedback('takeFrom');"
            required>
            <option v-for="option in provenances" :value="option.value">
              {{ $t(option.text) }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-form>
    </div>

    <template #modal-footer>
      <div>
        <div class="d-flex">
          <b-button variant="outline-primary" class="ml-auto mr-2" v-on:click="hideModal">{{ $t('Cancel') }}</b-button>
          <b-button variant="primary" v-on:click="addOrUpdateMovementOverride" :disabled="!hasChange">{{ $t('Add') }}</b-button>
        </div>
        <div class="mt-2" v-if="movement.isOverride">
          <b-link class="underline-text" v-on:click="deleteOverrideMovement">{{ $t("Revenir aux données initiales") }}</b-link>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import api from '../../services/api'
import i18n from "../../i18n";
import DatepickerInput from "../../components/b122/editFields/DatepickerInput.vue";

export default {
  name: 'TreasuryOverrideModal',

  components: {
    DatepickerInput
  },

  props: {
    movement: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      form: {
        date:
          {
            state: null,
            invalidFeedback: null,
            value: this.movement.date,
          },
        montant:
          {
            state: null,
            invalidFeedback: null,
            value: this.movement.montant,
          },
        takeFrom:
          {
            state: null,
            invalidFeedback: null,
            value: this.movement.takeFrom,
          },
      },
      errorOccurred: false,
      provenances: [
        {
          value: -1,
          text: "Automatique",
        },
        {
          value: 1,
          text: "Emprunt",
        },
        {
          value: 2,
          text: "Investisseurs",
        },
        {
          value: 3,
          text: "Trésorerie",
        }
      ],
    }
  },

  emits: ['didCloseModal'],

  computed: {
    hasChange() {
      return (
        this.form.date.value !== this.movement.date ||
        this.form.montant.value !== this.movement.montant ||
        this.form.takeFrom.value !== this.movement.takeFrom
      );
    }
  },

  methods: {

    emitCloseModal() {
      this.errorOccurred = false
      this.$emit("didCloseModal")
    },

    resetModal() {
      if (!this.errorOccurred) {
        this.form.montant.value = null
        this.form.date.value = null
        this.form.takeFrom.value = null
      }
    },

    removeInvalidFeedback(field) {
      this.form[field]['state'] = null
    },

    async addOrUpdateMovementOverride($event) {
      const form = this.$refs.formMovement;
      $event.preventDefault();

      if (!form.reportValidity()) {
        this.errorOccurred = true;
        return
      }

      const data = new FormData();
      data.append('objectUUID', this.movement.objectUUID);
      data.append('montant', this.form.montant.value);
      data.append('date', this.form.date.value);
      data.append('takeFrom', this.form.takeFrom.value);

      let url = `/treasury/addOrUpdateMovementOverride`

      try {
        const response = await api({
          method: 'POST',
          url: url,
          data: data
        });

        this.successToast();
        this.errorOccurred = false;
        this.resetModal();
        this.hideModal();
        this.$emit("didCloseModal")
      } catch (error) {
        console.error(error);
        this.errorOccurred = true;
        if (error.response && error.response.status === 403) {
          const invalidField = error.response.data.invalidField;
          this.form[invalidField].state = false;
          this.form[invalidField].invalidFeedback = i18n.t(error.response.data.message);
        }
      }
    },

    async deleteOverrideMovement() {

      const data = new FormData();
      data.append('objectUUID', this.movement.objectUUID);

      let url = `/treasury/deleteOverrideMovement`

      try {
        const response = await api({
          method: 'POST',
          url: url,
          data: data
        });

        this.successToast();
        this.errorOccurred = false;
        this.resetModal();
        this.hideModal();
        this.$emit("didCloseModal")
      } catch (error) {
        console.error(error);
        this.errorOccurred = true;
        if (error.response && error.response.status === 403) {
          const invalidField = error.response.data.invalidField;
          this.form[invalidField].state = false;
          this.form[invalidField].invalidFeedback = i18n.t(error.response.data.message);
        }
      }
    },

    hideModal() {
      this.$bvModal.hide('treasury-override-modal')
    },

    successToast() {
      this.$bvToast.toast(this.$i18n.t('Treasury.Update'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }

  }
}
</script>

<style scoped>
.modalHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/treasury/TreasuryOverrideModal.vue